import type { ReactNode } from "react";

function SectionCard({ title, children }: { title: string, children: ReactNode}) {
    return (
        <div className="tw-border tw-rounded-xl tw-p-5">
            <h6 className="tw-font-semibold tw-mb-3">{title}</h6>
            <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-x-4">
                {children}
            </div>
        </div>
    );
}

export default SectionCard;
